import { IEmployee } from '../../../services/employees.service';
import * as moment from 'moment';
import { EmployeesService, Masterdata } from "../../../services/index";
import { IEmployeeAvailability } from '../../../services/employeeAvailability.service';

interface IResolve {
    statuses: Masterdata[];
}

class AvailabilityItemController implements ng.IComponentController {
    private availability: IEmployeeAvailability;
    private statuses: Masterdata[];
    private resolve: IResolve;
    private employeeId: string;

    constructor(
        private EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private $timeout: ng.ITimeoutService,
        private SweetAlert: any,
        private $scope: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        // console.log('AvailabilityItemController onInit');
        this.statuses = this.resolve.statuses;
        this.employeeId = this.$stateParams["employeeId"];

        if (this.$stateParams["availabilityId"]) {
            this.EmployeesService.customGet('availability/' + this.$stateParams["availabilityId"]).then((result: any) => {
                this.availability = result;
                // console.log(this.availability);
                if (this.availability) {
                    this.availability.start = new Date(this.availability.start);
                    this.availability.end = new Date(this.availability.end);
                }
            });
        } else {
            this.availability = new IEmployeeAvailability();
            this.availability.start = this.roundMinutes(new Date());
            this.availability.end = moment(this.availability.start).add(8, 'hour').toDate();
        } 
    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    public submitAvailability() {

        this.$scope.availabilityForm.$setSubmitted();

        this.availability.start = moment(this.availability.start).format("YYYY-MM-DD HH:mm");
        this.availability.end = moment(this.availability.end).format("YYYY-MM-DD HH:mm");

        if (!this.availability.availabilityStatusId) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Vul een status in!',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Annuleren',
            }, (isConfirm) => {
                if (isConfirm) {

                }
            });
        } else if (moment(this.availability.start).isAfter(this.availability.end)) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Eindtijd ligt voor starttijd!',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Annuleren',
            }, (isConfirm) => {
                if (isConfirm) {

                }
            });
        } else {
            if (this.availability.id === undefined) {
                this.EmployeesService.customPost(this.employeeId + '/availability', this.availability).then((data) => {
                    this.closeModal();
                });
            } else {
                this.EmployeesService.customPut('availability/' + this.availability.id, this.availability).then((data) => {
                    this.closeModal();
                });
            }
        }
    }

    delete() {
        this.EmployeesService.customDelete('availability/' + this.availability.id).then(() => {
            this.closeModal();
        });
    }

    private closeModal() {
        this.$state.go('^', {tab: 3}, {reload: true});
    }
}

export const availabilityItemComponent: ng.IComponentOptions = {
    bindings: {
        resolve: '<'
    },
    controller: AvailabilityItemController,
    template: <string>require('./availability.item.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/hr/availability/availability.item.component.ts